module.exports = __webpack_public_path__ + "img/20200611_075345.3c0f63e0.jpg";